<template>
  <div class="swiper-container">
    <swiper
      ref="listSwiper"
      class="swiper-wrapper swiper-wrapper-n"
      :options="swiperOption"
    >
      <swiper-slide
        class="swiper-slide"
        v-for="(item, index) in items"
        :key="index"
      >
          <div class="sw-card" @click='goto(item)'>
            <img class="main-img" :src="item.image" />
            <p>{{ item.text }}</p>
            <p>{{ item.en }}</p>
          </div>
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { data } from "./data";
import browser from '@/utils/browser'

export default {
  computed: {
    swiper() {
      return this.$refs.listSwiper.$swiper;
    },
    swiperOption() {
      // let that = this
      return {
        slidesPerView: "auto",
        autoplay: false,
        direction : this.isMobile ? 'vertical' : 'horizontal'
      };
    },
    items() {
      return data['cjxz'];
    }
  },
  data() {
    return {
      showNext: 0,
      showPre: 0,
      isMobile: browser.mobile
    };
  },
  methods: {
    
    goto(item) {
      
      let {url,noMusic,scene} = item
      if (url === this.$route.query.ifr) {
        return
      }
      if (scene) {
       return window.location.href = url
      }

      this.$router.push({
          name:'list',
          query:{
            ifr:url || '',
            noMusic,
            scene
          }
        })
      this.$emit('close',true)
     
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  props:['activeType'],
  mounted() {
    this.$emit("swiper1", this.swiper);
  },
};
</script>
<style lang="less" scoped>
.swiper-container {
  height: 208px;
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  .swiper-wrapper {
    height: 208px;
    width: 100%;
    float: right;
    background: linear-gradient(to right,#0075BC,#06816F);
    .swiper-slide {
      transform-style: preserve-3d;
      height: auto!important;
      width: 200px;
      padding: 10px;
      cursor: pointer;
      .sw-card{
        text-align: center;
        margin-bottom: 6px;
        img {
          overflow: hidden;
          width: 100%;
          margin-top: 10px;
        }
        p{
          color: #fff;
          text-align: left;
          margin: 0 10px;
          font-size: 12px;
          &:first-of-type{
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 500px) {
  .swiper-container {
    height: 100%;
    width: 50%;
    position: fixed;
    right: 0;
    top: 0;
    left: unset;
    bottom: unset;
    .swiper-wrapper {
      width: 50%;
      height: 100%;
      float: right;
      .swiper-slide {
        transform-style: preserve-3d;
        height: auto!important;
        padding: 0;
        width: auto;
        .sw-card{
          text-align: center;
          margin-bottom: 6px;
          img {
            overflow: hidden;
            width: calc(100% - 20px);
            margin-top: 10px;
          }
          p{
            color: #fff;
            text-align: left;
            margin: 0 10px;
            font-size: 12px;
            &:first-of-type{
              font-size: 14px;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
}
</style>
